module.exports = __webpack_public_path__ + "static/media/partySvg.ae273def.svg";